import React, { useState } from 'react';
import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    IconButton,
    Slider,
    Tooltip,
    Menu,
    Checkbox,
    FormControlLabel,
    // Chip,
} from '@mui/material';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BarChartIcon from '@mui/icons-material/BarChart';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
// import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

// ─── Table Data ───────────────────────────────────────────────────────────────

const scheduleData = [
    { no: 1,  route: 'RT-101', schedule: 'SCH-01', depTime: '06:30', direction: 'Up',   depot: 'Depot A', trips: 120, passengers: 4800, loadFactor: 80, revenue: 960000,  avgRevPerTrip: 8000, onTime: 92, cancellations: 2, rank: 1 },
    { no: 2,  route: 'RT-101', schedule: 'SCH-02', depTime: '08:30', direction: 'Up',   depot: 'Depot A', trips: 118, passengers: 4130, loadFactor: 69, revenue: 861600,  avgRevPerTrip: 7300, onTime: 89, cancellations: 3, rank: 2 },
    { no: 3,  route: 'RT-101', schedule: 'SCH-03', depTime: '10:30', direction: 'Up',   depot: 'Depot A', trips: 116, passengers: 3480, loadFactor: 58, revenue: 788400,  avgRevPerTrip: 6800, onTime: 85, cancellations: 4, rank: 3 },
    { no: 4,  route: 'RT-101', schedule: 'SCH-04', depTime: '12:30', direction: 'Up',   depot: 'Depot A', trips: 115, passengers: 2760, loadFactor: 46, revenue: 717500,  avgRevPerTrip: 6240, onTime: 78, cancellations: 4, rank: 6 },
    { no: 5,  route: 'RT-102', schedule: 'SCH-01', depTime: '07:00', direction: 'Down', depot: 'Depot B', trips: 122, passengers: 4950, loadFactor: 82, revenue: 1020000, avgRevPerTrip: 8361, onTime: 91, cancellations: 1, rank: 1 },
    { no: 6,  route: 'RT-102', schedule: 'SCH-02', depTime: '09:00', direction: 'Down', depot: 'Depot B', trips: 121, passengers: 3910, loadFactor: 65, revenue: 842800,  avgRevPerTrip: 6966, onTime: 86, cancellations: 2, rank: 4 },
    { no: 7,  route: 'RT-102', schedule: 'SCH-03', depTime: '11:00', direction: 'Down', depot: 'Depot B', trips: 119, passengers: 2990, loadFactor: 49, revenue: 672750,  avgRevPerTrip: 5649, onTime: 73, cancellations: 3, rank: 7 },
    { no: 8,  route: 'RT-103', schedule: 'SCH-01', depTime: '06:45', direction: 'Up',   depot: 'Depot C', trips: 117, passengers: 4220, loadFactor: 70, revenue: 884100,  avgRevPerTrip: 7556, onTime: 88, cancellations: 1, rank: 3 },
    { no: 9,  route: 'RT-103', schedule: 'SCH-02', depTime: '08:45', direction: 'Up',   depot: 'Depot C', trips: 116, passengers: 3560, loadFactor: 59, revenue: 788000,  avgRevPerTrip: 6793, onTime: 84, cancellations: 2, rank: 5 },
    { no: 10, route: 'RT-103', schedule: 'SCH-03', depTime: '10:45', direction: 'Up',   depot: 'Depot C', trips: 114, passengers: 2430, loadFactor: 40, revenue: 612300,  avgRevPerTrip: 5371, onTime: 71, cancellations: 3, rank: 8 },
    { no: 11, route: 'RT-104', schedule: 'SCH-01', depTime: '07:15', direction: 'Up',   depot: 'Depot A', trips: 120, passengers: 4560, loadFactor: 76, revenue: 912000,  avgRevPerTrip: 7600, onTime: 90, cancellations: 2, rank: 2 },
    { no: 12, route: 'RT-104', schedule: 'SCH-02', depTime: '09:15', direction: 'Up',   depot: 'Depot A', trips: 118, passengers: 3780, loadFactor: 63, revenue: 826200,  avgRevPerTrip: 7002, onTime: 87, cancellations: 3, rank: 5 },
    { no: 13, route: 'RT-104', schedule: 'SCH-03', depTime: '11:15', direction: 'Up',   depot: 'Depot A', trips: 115, passengers: 2890, loadFactor: 52, revenue: 724500,  avgRevPerTrip: 6300, onTime: 80, cancellations: 4, rank: 7 },
    { no: 14, route: 'RT-105', schedule: 'SCH-01', depTime: '06:00', direction: 'Down', depot: 'Depot B', trips: 123, passengers: 5120, loadFactor: 85, revenue: 1050600, avgRevPerTrip: 8541, onTime: 93, cancellations: 1, rank: 1 },
    { no: 15, route: 'RT-105', schedule: 'SCH-02', depTime: '08:00', direction: 'Down', depot: 'Depot B', trips: 121, passengers: 4200, loadFactor: 70, revenue: 889350,  avgRevPerTrip: 7350, onTime: 88, cancellations: 2, rank: 3 },
    { no: 16, route: 'RT-105', schedule: 'SCH-03', depTime: '10:00', direction: 'Down', depot: 'Depot B', trips: 118, passengers: 3340, loadFactor: 56, revenue: 748700,  avgRevPerTrip: 6345, onTime: 81, cancellations: 3, rank: 6 },
    { no: 17, route: 'RT-106', schedule: 'SCH-01', depTime: '07:30', direction: 'Up',   depot: 'Depot C', trips: 116, passengers: 4010, loadFactor: 67, revenue: 858600,  avgRevPerTrip: 7402, onTime: 87, cancellations: 2, rank: 4 },
    { no: 18, route: 'RT-106', schedule: 'SCH-02', depTime: '09:30', direction: 'Up',   depot: 'Depot C', trips: 114, passengers: 3150, loadFactor: 53, revenue: 722700,  avgRevPerTrip: 6340, onTime: 82, cancellations: 3, rank: 6 },
    { no: 19, route: 'RT-106', schedule: 'SCH-03', depTime: '11:30', direction: 'Up',   depot: 'Depot C', trips: 112, passengers: 2340, loadFactor: 39, revenue: 591360,  avgRevPerTrip: 5280, onTime: 70, cancellations: 4, rank: 9 },
    { no: 20, route: 'RT-107', schedule: 'SCH-01', depTime: '06:15', direction: 'Down', depot: 'Depot A', trips: 121, passengers: 4680, loadFactor: 78, revenue: 933720,  avgRevPerTrip: 7717, onTime: 91, cancellations: 1, rank: 2 },
    { no: 21, route: 'RT-107', schedule: 'SCH-02', depTime: '08:15', direction: 'Down', depot: 'Depot A', trips: 119, passengers: 3820, loadFactor: 64, revenue: 833900,  avgRevPerTrip: 7008, onTime: 86, cancellations: 2, rank: 5 },
    { no: 22, route: 'RT-107', schedule: 'SCH-03', depTime: '10:15', direction: 'Down', depot: 'Depot A', trips: 117, passengers: 2960, loadFactor: 49, revenue: 683460,  avgRevPerTrip: 5841, onTime: 74, cancellations: 3, rank: 8 },
    { no: 23, route: 'RT-108', schedule: 'SCH-01', depTime: '07:00', direction: 'Up',   depot: 'Depot B', trips: 120, passengers: 4520, loadFactor: 75, revenue: 904800,  avgRevPerTrip: 7540, onTime: 90, cancellations: 2, rank: 3 },
    { no: 24, route: 'RT-108', schedule: 'SCH-02', depTime: '09:00', direction: 'Up',   depot: 'Depot B', trips: 118, passengers: 3660, loadFactor: 61, revenue: 796980,  avgRevPerTrip: 6754, onTime: 84, cancellations: 3, rank: 6 },
    { no: 25, route: 'RT-108', schedule: 'SCH-03', depTime: '11:00', direction: 'Up',   depot: 'Depot B', trips: 115, passengers: 2800, loadFactor: 47, revenue: 650250,  avgRevPerTrip: 5654, onTime: 75, cancellations: 4, rank: 9 },
    { no: 26, route: 'RT-109', schedule: 'SCH-01', depTime: '06:30', direction: 'Down', depot: 'Depot C', trips: 122, passengers: 4890, loadFactor: 81, revenue: 998580,  avgRevPerTrip: 8185, onTime: 92, cancellations: 1, rank: 1 },
    { no: 27, route: 'RT-109', schedule: 'SCH-02', depTime: '08:30', direction: 'Down', depot: 'Depot C', trips: 120, passengers: 4050, loadFactor: 68, revenue: 864000,  avgRevPerTrip: 7200, onTime: 87, cancellations: 2, rank: 4 },
    { no: 28, route: 'RT-109', schedule: 'SCH-03', depTime: '10:30', direction: 'Down', depot: 'Depot C', trips: 118, passengers: 3120, loadFactor: 52, revenue: 738420,  avgRevPerTrip: 6258, onTime: 80, cancellations: 3, rank: 7 },
    { no: 29, route: 'RT-110', schedule: 'SCH-01', depTime: '07:45', direction: 'Up',   depot: 'Depot A', trips: 119, passengers: 4350, loadFactor: 73, revenue: 880600,  avgRevPerTrip: 7400, onTime: 89, cancellations: 2, rank: 3 },
    { no: 30, route: 'RT-110', schedule: 'SCH-02', depTime: '09:45', direction: 'Up',   depot: 'Depot A', trips: 117, passengers: 3480, loadFactor: 58, revenue: 758610,  avgRevPerTrip: 6484, onTime: 83, cancellations: 3, rank: 6 },
    { no: 31, route: 'RT-110', schedule: 'SCH-03', depTime: '11:45', direction: 'Up',   depot: 'Depot A', trips: 114, passengers: 2580, loadFactor: 43, revenue: 614340,  avgRevPerTrip: 5389, onTime: 72, cancellations: 4, rank: 9 },
    { no: 32, route: 'RT-111', schedule: 'SCH-01', depTime: '06:00', direction: 'Down', depot: 'Depot B', trips: 123, passengers: 5000, loadFactor: 83, revenue: 1025100, avgRevPerTrip: 8334, onTime: 92, cancellations: 1, rank: 1 },
    { no: 33, route: 'RT-111', schedule: 'SCH-02', depTime: '08:00', direction: 'Down', depot: 'Depot B', trips: 121, passengers: 4100, loadFactor: 68, revenue: 871590,  avgRevPerTrip: 7202, onTime: 88, cancellations: 2, rank: 4 },
    { no: 34, route: 'RT-111', schedule: 'SCH-03', depTime: '10:00', direction: 'Down', depot: 'Depot B', trips: 118, passengers: 3200, loadFactor: 53, revenue: 732660,  avgRevPerTrip: 6209, onTime: 79, cancellations: 3, rank: 7 },
    { no: 35, route: 'RT-112', schedule: 'SCH-01', depTime: '07:30', direction: 'Up',   depot: 'Depot C', trips: 120, passengers: 4400, loadFactor: 73, revenue: 895200,  avgRevPerTrip: 7460, onTime: 90, cancellations: 2, rank: 2 },
    { no: 36, route: 'RT-112', schedule: 'SCH-02', depTime: '09:30', direction: 'Up',   depot: 'Depot C', trips: 118, passengers: 3540, loadFactor: 59, revenue: 774540,  avgRevPerTrip: 6564, onTime: 84, cancellations: 3, rank: 5 },
    { no: 37, route: 'RT-112', schedule: 'SCH-03', depTime: '11:30', direction: 'Up',   depot: 'Depot C', trips: 115, passengers: 2640, loadFactor: 44, revenue: 626850,  avgRevPerTrip: 5451, onTime: 73, cancellations: 4, rank: 8 },
    { no: 38, route: 'RT-113', schedule: 'SCH-01', depTime: '06:15', direction: 'Down', depot: 'Depot A', trips: 122, passengers: 4760, loadFactor: 79, revenue: 948520,  avgRevPerTrip: 7774, onTime: 91, cancellations: 1, rank: 2 },
    { no: 39, route: 'RT-113', schedule: 'SCH-02', depTime: '08:15', direction: 'Down', depot: 'Depot A', trips: 120, passengers: 3900, loadFactor: 65, revenue: 835200,  avgRevPerTrip: 6960, onTime: 86, cancellations: 2, rank: 5 },
    { no: 40, route: 'RT-113', schedule: 'SCH-03', depTime: '10:15', direction: 'Down', depot: 'Depot A', trips: 117, passengers: 3020, loadFactor: 50, revenue: 701010,  avgRevPerTrip: 5991, onTime: 77, cancellations: 3, rank: 8 },
    { no: 41, route: 'RT-114', schedule: 'SCH-01', depTime: '07:00', direction: 'Up',   depot: 'Depot B', trips: 121, passengers: 4580, loadFactor: 76, revenue: 915550,  avgRevPerTrip: 7567, onTime: 90, cancellations: 2, rank: 3 },
    { no: 42, route: 'RT-114', schedule: 'SCH-02', depTime: '09:00', direction: 'Up',   depot: 'Depot B', trips: 119, passengers: 3700, loadFactor: 62, revenue: 797090,  avgRevPerTrip: 6698, onTime: 83, cancellations: 3, rank: 6 },
];

// ─── Load factor color helper ─────────────────────────────────────────────────

const loadFactorChip = (val) => {
    let color, bg;
    if (val >= 75)      { color = '#2e7d32'; bg = '#e8f5e9'; }
    else if (val >= 60) { color = '#ed6c02'; bg = '#fff3e0'; }
    else if (val >= 45) { color = '#f57c00'; bg = '#fff8e1'; }
    else                { color = '#d32f2f'; bg = '#ffebee'; }
    return (
        <Box sx={{ display: 'inline-block', px: 1.2, py: 0.25, borderRadius: 1, backgroundColor: bg, color, fontWeight: 700, fontSize: 12, minWidth: 46, textAlign: 'center' }}>
            {val}%
        </Box>
    );
};

const onTimeChip = (val) => {
    let color, bg;
    if (val >= 90)      { color = '#2e7d32'; bg = '#e8f5e9'; }
    else if (val >= 80) { color = '#ed6c02'; bg = '#fff3e0'; }
    else                { color = '#d32f2f'; bg = '#ffebee'; }
    return (
        <Box sx={{ display: 'inline-block', px: 1.2, py: 0.25, borderRadius: 1, backgroundColor: bg, color, fontWeight: 700, fontSize: 12, minWidth: 46, textAlign: 'center' }}>
            {val}%
        </Box>
    );
};

const rankBadge = (rank) => {
    const medals = { 1: '🥇', 2: '🥈', 3: '🥉' };
    if (medals[rank]) return <Typography sx={{ fontSize: 18, lineHeight: 1 }}>{medals[rank]}</Typography>;
    return <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#888' }}>{rank}</Typography>;
};

// ─── All column definitions ───────────────────────────────────────────────────

const ALL_COLUMNS = [
    { key: 'no',           label: 'No.',                  always: true },
    { key: 'route',        label: 'Route Code',           always: true },
    { key: 'schedule',     label: 'Schedule Code' },
    { key: 'depTime',      label: 'Departure Time' },
    { key: 'direction',    label: 'Direction' },
    { key: 'depot',        label: 'Assigned Depot' },
    { key: 'trips',        label: 'Total Trips' },
    { key: 'passengers',   label: 'Total Passengers' },
    { key: 'loadFactor',   label: 'Avg Load Factor %' },
    { key: 'revenue',      label: 'Total Revenue' },
    { key: 'avgRevPerTrip',label: 'Avg Revenue per Trip' },
    { key: 'onTime',       label: 'On-Time %' },
    { key: 'cancellations',label: 'Cancellation Count' },
    { key: 'rank',         label: 'Rank' },
    { key: 'action',       label: 'Action',               always: true },
];

// ─── Component ────────────────────────────────────────────────────────────────

const ScheduleEfficiencyPage = () => {
    const [routeCode, setRouteCode]     = useState('');
    const [direction, setDirection]     = useState('');
    const [depot, setDepot]             = useState('');
    const [loadFactorRange, setLoadFactorRange] = useState([0, 100]);
    const [onTimeRange, setOnTimeRange]         = useState([0, 100]);

    const [showEntries, setShowEntries] = useState(10);
    const [page, setPage]               = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Column visibility
    const defaultVisible = ALL_COLUMNS.reduce((acc, c) => ({ ...acc, [c.key]: true }), {});
    const [visibleCols, setVisibleCols] = useState(defaultVisible);
    const [colMenuAnchor, setColMenuAnchor] = useState(null);

    const handleChangePage        = (_, p)  => setPage(p);
    const handleChangeRowsPerPage = (e)     => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };
    const startIndex = page * rowsPerPage;

    const thSx = { py: 1, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap' };
    const tdSx = { py: 0.5, fontSize: 12 };

    const visibleColumnDefs = ALL_COLUMNS.filter(c => visibleCols[c.key]);

    return (
        <Container component="main" maxWidth={false} sx={{ py: 0, px: { xs: 2, sm: 3 } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>

                {/* ── Page Header ── */}
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        Schedule Efficiency &amp; Comparative Performance
                    </Typography>
                </Box>

                {/* ── Filter Panel ── */}
                <Paper variant="outlined" sx={{ width: '100%', p: 2.5, borderRadius: 2, mb: 3 }}>
                    {/* Row 1: dropdowns + date range + reset */}
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2,1fr)', md: 'repeat(4,1fr) auto' },
                        gap: 2,
                        mb: 2.5,
                        alignItems: 'flex-end',
                    }}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Route Code</InputLabel>
                            <Select value={routeCode} onChange={e => setRouteCode(e.target.value)} label="Route Code">
                                <MenuItem value="">All Routes</MenuItem>
                                <MenuItem value="RT-101">RT-101</MenuItem>
                                <MenuItem value="RT-102">RT-102</MenuItem>
                                <MenuItem value="RT-103">RT-103</MenuItem>
                                <MenuItem value="RT-104">RT-104</MenuItem>
                                <MenuItem value="RT-105">RT-105</MenuItem>
                                <MenuItem value="RT-106">RT-106</MenuItem>
                                <MenuItem value="RT-107">RT-107</MenuItem>
                                <MenuItem value="RT-108">RT-108</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth size="small">
                            <InputLabel>Direction</InputLabel>
                            <Select value={direction} onChange={e => setDirection(e.target.value)} label="Direction">
                                <MenuItem value="">All Directions</MenuItem>
                                <MenuItem value="Up">Up</MenuItem>
                                <MenuItem value="Down">Down</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth size="small">
                            <InputLabel>Assigned Depot</InputLabel>
                            <Select value={depot} onChange={e => setDepot(e.target.value)} label="Assigned Depot">
                                <MenuItem value="">All Depots</MenuItem>
                                <MenuItem value="Depot A">Depot A</MenuItem>
                                <MenuItem value="Depot B">Depot B</MenuItem>
                                <MenuItem value="Depot C">Depot C</MenuItem>
                                <MenuItem value="Colombo Depot">Colombo Depot</MenuItem>
                                <MenuItem value="Kandy Depot">Kandy Depot</MenuItem>
                                <MenuItem value="Galle Depot">Galle Depot</MenuItem>
                                <MenuItem value="Negombo Depot">Negombo Depot</MenuItem>
                            </Select>
                        </FormControl>

                        {/* Date Range */}
                        <FormControl fullWidth size="small">
                            <InputLabel>Date Range</InputLabel>
                            <Select defaultValue="may2026" label="Date Range">
                                <MenuItem value="may2026">01 May 2026 – 31 May 2026</MenuItem>
                                <MenuItem value="apr2026">01 Apr 2026 – 30 Apr 2026</MenuItem>
                                <MenuItem value="mar2026">01 Mar 2026 – 31 Mar 2026</MenuItem>
                            </Select>
                        </FormControl>

                        <Button
                            variant="outlined"
                            sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 600, height: 40, whiteSpace: 'nowrap', px: 3 }}
                        >
                            Reset
                        </Button>
                    </Box>

                    {/* Row 2: sliders + Apply Filters */}
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr auto' },
                        gap: 3,
                        alignItems: 'center',
                    }}>
                        {/* Min Load Factor slider */}
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, mb: 0.5 }}>
                                Min Load Factor (%)
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Slider
                                        value={loadFactorRange}
                                        onChange={(_, v) => setLoadFactorRange(v)}
                                        valueLabelDisplay="auto"
                                        min={0} max={100}
                                        sx={{ color: '#1976d2' }}
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
                                        <Typography variant="caption" color="text.secondary">0%</Typography>
                                        <Typography variant="caption" color="text.secondary">100%</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{
                                    border: '1px solid #e0e0e0', borderRadius: 1, px: 1.2, py: 0.4,
                                    fontSize: 12, color: '#555', whiteSpace: 'nowrap', minWidth: 80, textAlign: 'center',
                                }}>
                                    {loadFactorRange[0]}% – {loadFactorRange[1]}%
                                </Box>
                            </Box>
                        </Box>

                        {/* On-Time slider */}
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, mb: 0.5 }}>
                                On-Time (%)
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Slider
                                        value={onTimeRange}
                                        onChange={(_, v) => setOnTimeRange(v)}
                                        valueLabelDisplay="auto"
                                        min={0} max={100}
                                        sx={{ color: '#1976d2' }}
                                    />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5 }}>
                                        <Typography variant="caption" color="text.secondary">0%</Typography>
                                        <Typography variant="caption" color="text.secondary">100%</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{
                                    border: '1px solid #e0e0e0', borderRadius: 1, px: 1.2, py: 0.4,
                                    fontSize: 12, color: '#555', whiteSpace: 'nowrap', minWidth: 80, textAlign: 'center',
                                }}>
                                    {onTimeRange[0]}% – {onTimeRange[1]}%
                                </Box>
                            </Box>
                        </Box>

                        {/* Apply Filters button */}
                        <Button
                            variant="contained"
                            sx={{ borderRadius: '4px', textTransform: 'none', fontWeight: 'bold', height: 40, backgroundColor: '#3f51b5', '&:hover': { backgroundColor: '#303f9f' }, whiteSpace: 'nowrap', px: 3, alignSelf: 'center' }}
                        >
                            Apply Filters
                        </Button>
                    </Box>
                </Paper>

                {/* ══════════════════════════════════════════
                    TABLE 3.2.A — Schedule Performance Comparison
                ══════════════════════════════════════════ */}
                <Paper variant="outlined" sx={{ width: '100%', borderRadius: 2 }}>

                    {/* Table toolbar */}
                    <Box sx={{ px: 2, pt: 2, pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1.5 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            Table 3.2.A — Schedule Performance Comparison
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            {/* Show entries */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body2" sx={{ fontSize: 13 }}>Show</Typography>
                                <FormControl size="small" sx={{ minWidth: 70 }}>
                                    <Select
                                        value={showEntries}
                                        onChange={e => { setShowEntries(Number(e.target.value)); setRowsPerPage(Number(e.target.value)); setPage(0); }}
                                        sx={{ fontSize: 13, height: 32 }}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography variant="body2" sx={{ fontSize: 13 }}>entries</Typography>
                            </Box>

                            {/* Column Visibility */}
                            <Button
                                variant="outlined"
                                startIcon={<ViewColumnIcon />}
                                size="small"
                                onClick={e => setColMenuAnchor(e.currentTarget)}
                                sx={{ textTransform: 'none', fontWeight: 600, fontSize: 13, height: 32 }}
                            >
                                Column Visibility
                            </Button>
                            <Menu anchorEl={colMenuAnchor} open={Boolean(colMenuAnchor)} onClose={() => setColMenuAnchor(null)}>
                                <Box sx={{ px: 2, py: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>Toggle Columns</Typography>
                                    {ALL_COLUMNS.filter(c => !c.always).map(col => (
                                        <Box key={col.key}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={visibleCols[col.key]}
                                                        onChange={e => setVisibleCols(prev => ({ ...prev, [col.key]: e.target.checked }))}
                                                    />
                                                }
                                                label={<Typography sx={{ fontSize: 13 }}>{col.label}</Typography>}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            </Menu>
                        </Box>
                    </Box>

                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#7cdffa4b' }}>
                                    {visibleColumnDefs.map(col => (
                                        <TableCell key={col.key} sx={thSx} align={['revenue','avgRevPerTrip','trips','passengers','cancellations'].includes(col.key) ? 'right' : 'center'}>
                                            {col.label}
                                            {(col.key === 'loadFactor' || col.key === 'onTime' || col.key === 'cancellations') &&
                                                <Tooltip title={col.key === 'loadFactor' ? 'Average passenger load as % of capacity' : col.key === 'onTime' ? 'Percentage of trips arriving on schedule' : 'Number of cancelled trips in period'} arrow>
                                                    <InfoOutlinedIcon sx={{ fontSize: 13, ml: 0.4, verticalAlign: 'middle', color: '#888' }} />
                                                </Tooltip>
                                            }
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {scheduleData
                                    .slice(startIndex, startIndex + rowsPerPage)
                                    .map(row => (
                                        <TableRow key={`${row.route}-${row.schedule}`} hover>
                                            {visibleCols['no']            && <TableCell sx={tdSx} align="center">{row.no}</TableCell>}
                                            {visibleCols['route']         && <TableCell sx={{ ...tdSx, fontWeight: 600 }} align="center">{row.route}</TableCell>}
                                            {visibleCols['schedule']      && <TableCell sx={tdSx} align="center">{row.schedule}</TableCell>}
                                            {visibleCols['depTime']       && <TableCell sx={tdSx} align="center">{row.depTime}</TableCell>}
                                            {visibleCols['direction']     && <TableCell sx={tdSx} align="center">{row.direction}</TableCell>}
                                            {visibleCols['depot']         && <TableCell sx={tdSx} align="center">{row.depot}</TableCell>}
                                            {visibleCols['trips']         && <TableCell sx={tdSx} align="right">{row.trips}</TableCell>}
                                            {visibleCols['passengers']    && <TableCell sx={tdSx} align="right">{row.passengers.toLocaleString()}</TableCell>}
                                            {visibleCols['loadFactor']    && <TableCell sx={tdSx} align="center">{loadFactorChip(row.loadFactor)}</TableCell>}
                                            {visibleCols['revenue']       && <TableCell sx={tdSx} align="right">Rs. {row.revenue.toLocaleString()}</TableCell>}
                                            {visibleCols['avgRevPerTrip'] && <TableCell sx={{ ...tdSx, fontWeight: 600, color: '#2e7d32' }} align="right">Rs. {row.avgRevPerTrip.toLocaleString()}</TableCell>}
                                            {visibleCols['onTime']        && <TableCell sx={tdSx} align="center">{onTimeChip(row.onTime)}</TableCell>}
                                            {visibleCols['cancellations'] && <TableCell sx={tdSx} align="right">{row.cancellations}</TableCell>}
                                            {visibleCols['rank']          && <TableCell sx={tdSx} align="center">{rankBadge(row.rank)}</TableCell>}
                                            {visibleCols['action']        && (
                                                <TableCell sx={tdSx} align="center">
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.3 }}>
                                                        <IconButton size="small" color="primary"><VisibilityIcon sx={{ fontSize: 17 }} /></IconButton>
                                                        <IconButton size="small" color="primary"><BarChartIcon sx={{ fontSize: 17 }} /></IconButton>
                                                        <IconButton size="small"><MoreVertIcon sx={{ fontSize: 17 }} /></IconButton>
                                                    </Box>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1, flexWrap: 'wrap', gap: 1 }}>
                        <Typography variant="caption" color="text.secondary">
                            Showing {startIndex + 1} to {Math.min(startIndex + rowsPerPage, scheduleData.length)} of {scheduleData.length} entries
                        </Typography>
                        <TablePagination
                            showFirstButton
                            showLastButton
                            component="div"
                            count={scheduleData.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 25, 50]}
                            labelRowsPerPage=""
                            sx={{ '.MuiTablePagination-toolbar': { minHeight: 40, p: 0 }, '.MuiTablePagination-selectLabel': { display: 'none' }, '.MuiTablePagination-select': { display: 'none' }, '.MuiTablePagination-selectIcon': { display: 'none' } }}
                        />
                    </Box>
                </Paper>

            </Box>
        </Container>
    );
};

export default ScheduleEfficiencyPage;